module.exports = __webpack_public_path__ + "static/media/money.7080fe96.svg";